import React from 'react'
import { arrayOf, bool, func, shape, string } from 'prop-types'
import { ChoiceChips, Expander, ExpanderContent, ExpanderHeader } from '@fs/zion-ui'
import { css } from '@emotion/core'

export default function NameSelector({ choices, selectionChange, justify }) {
  const strippedChoices = choices.map((choice) => {
    return {
      label: choice.label,
      value: choice.value,
      isfirst: choice.isFirst,
      selected: choice.selected,
    }
  })
  const chipCss = css`
    display: flex;
    flex-direction: column;
    > div > div {
      justify-content: ${justify};
    }
  `
  const lastChoices = strippedChoices.slice(10)
  return (
    <div css={chipCss}>
      {lastChoices && lastChoices.length > 0 ? (
        <Expander>
          <ExpanderContent collapsedHeight="70px">
            <ChoiceChips
              name="selectedName"
              label=""
              onSelectionChange={(selectedChip) => {
                const matchingChoice = choices.find((rawChoice) => {
                  return rawChoice.value === selectedChip.value
                })
                selectionChange({ ...selectedChip, isFirst: matchingChoice.isFirst })
              }}
              chips={strippedChoices}
            />
          </ExpanderContent>
          <ExpanderHeader />
        </Expander>
      ) : (
        <ChoiceChips
          name="selectedName"
          label=""
          onSelectionChange={(selectedChip) => {
            const matchingChoice = choices.find((rawChoice) => {
              return rawChoice.value === selectedChip.value
            })
            selectionChange({ ...selectedChip, isFirst: matchingChoice.isFirst })
          }}
          chips={strippedChoices}
        />
      )}
    </div>
  )
}

NameSelector.propTypes = {
  selectionChange: func,
  justify: string,
  choices: arrayOf(
    shape({
      isFirst: bool,
      label: string,
      selected: bool,
      value: string,
    })
  ),
}
